import { AwsConfig as AwsConstants } from '../Constants';

import { IAudit } from '@interfaces/ehss/IAudit';
import BaseService, { RequestInterface } from '../Base';
import IWorkflow from '@interfaces/IWorkflow';

export default class AuditService extends BaseService {
    constructor () {
        super(AwsConstants.API_EHSS, 'audit');
    }
    async listAll (unitId: string,fields?: string[]): Promise<IAudit[]> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;
        const res = await super.get<IAudit[]>('all', params);
        return res;
    }

    async listByIds (unitId: string, ids: string[],fields?: string[]): Promise<IAudit[]> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;
        params.queryStringParameters['ids'] = ids.join(',');

        const res = await super.get<IAudit[]>('', params);
        return res;
    }

    async getById (id: string, unitId: string, fields?: string[]): Promise<IAudit> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;
        const res = await super.get<IAudit>(id, params);
        return res;
    }
    async create (data: IAudit, unitId: string): Promise<IAudit> {
        const params: RequestInterface = {
            body: data,
            queryStringParameters: { unit: unitId }
        };
        const res = await super.post<IAudit>('', params);
        return res;
    }
    async updateById (id: string, data: IAudit, unitId: string): Promise<IAudit> {
        const params: RequestInterface = {
            body: data,
            queryStringParameters: { unit: unitId }
        };
        const res = await super.put<IAudit>(id, params);
        return res;
    }
    async deleteById (id: string, unitId: string): Promise<void> {
        const params: RequestInterface = {
            queryStringParameters: { unit: unitId }
        };
        await super.delete<void>(id, params);
    }

    async setWorkflow (auditId: string, workflow: IWorkflow, unitId: string): Promise<IAudit> {
        const params: RequestInterface = {
            body: workflow,
            queryStringParameters: { unit: unitId }
        };
        const res = await super.patch<IAudit>(`${auditId}/workflow`, params);
        return res;
    }
}
